import { EActionTypes } from './types';
import { actionGenerator } from '../../utils/actionGenerator';
var REQUEST = EActionTypes.GET_ADDRESS_GEO_SUGGEST_REQUEST,
    SUCCESS = EActionTypes.GET_ADDRESS_GEO_SUGGEST_SUCCESS,
    FAILURE = EActionTypes.GET_ADDRESS_GEO_SUGGEST_FAILURE;
export var requestAction = actionGenerator(REQUEST);
export var successAction = actionGenerator(SUCCESS);
export var failureAction = actionGenerator(FAILURE);